import '../../App.css'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import axios from 'axios'
import Aside from '../../component/aside'
import { useNavigate, useParams } from 'react-router-dom'
import { formatSecondsToTime } from '../../component/formatSecondsToTime'
import Navbar from '../../component/navbar'
import { FormJsonToShamsiDay } from '../../component/FormJsonToShamsiDay'
import Loading from '../../component/loading'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { FormJsonToShamsiTime } from '../../component/FormJsonToShamsiTime'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faUser,
    faIdCard,
    faCalendarDay,
    faClock,
    faCalendarAlt,
    faUserTie,
    faComment,
    faCheck,
    faTimes,
    faAngleLeft,
} from '@fortawesome/free-solid-svg-icons'
import { AppContextMenu } from '../../App'

function FurloughGetViewManagment() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('furloughGetManagment')
    }, [])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [dataGet, setDataGet] = useState([])
    const [notFound, setNotFound] = useState(false)
    const [furloughMonthTime, setFurloughMonthTime] = useState('')
    const [confirmedUsers, setConfirmedUsers] = useState([])
    const [approvalSteps, setApprovalSteps] = useState([])

    let user = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { role: '' }
    const { id } = useParams()
    let navigate = useNavigate()

    useEffect(() => {
        getFurlough()
    }, [])

    const getFurlough = async () => {
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-request/${id}`,
            },
            resolve: (res) => {
                setDataGet(res.data)
                getFurloughMonth(res.data.user_id, res.data.start_date)

                // استخراج اطلاعات از داده‌های API
                setConfirmedUsers(res.data?.confirm_users || [])
                const nextApprover = res.data?.last_requested_position
                const userDepartment = res.data?.last_requested_department

                // ایجاد آرایه مراحل تایید

                if (res.data?.status === 'reject') {
                    setApprovalSteps([
                        ...res.data?.confirm_users.map((user, index) => ({
                            id: `confirmed-${index}`,
                            name: user?.user?.full_name,
                            role: user?.position?.name,
                            department: user?.department.name,
                            status: user?.status,
                            comment: user?.description,
                        })),
                    ])
                } else if (res.data?.status === 'confirm') {
                    setApprovalSteps([
                        ...res.data?.confirm_users.map((user, index) => ({
                            id: `confirmed-${index}`,
                            name: user?.user?.full_name,
                            role: user?.position?.name,
                            department: user?.department.name,
                            status: user?.status,
                            comment: user?.description,
                        })),
                    ])
                } else {
                    setApprovalSteps([
                        ...res.data?.confirm_users.map((user, index) => ({
                            id: `confirmed-${index}`,
                            name: user?.user?.full_name,
                            role: user?.position?.name,
                            department: user?.department.name,
                            status: user?.status,
                            comment: user?.description,
                        })),
                        {
                            id: 'next-approver',
                            name: nextApprover?.name,
                            role: 'مرحله بعدی تایید',
                            department: userDepartment?.name,
                            status: 'pending',
                            comment: 'در انتظار تایید',
                        },
                    ])
                }

                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getFurloughMonth = async (userId, date) => {
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-request/current-month/${userId}?date=${date}`,
            },
            resolve: (res) => {
                setFurloughMonthTime(res.data)
            },
            reject: (error) => {
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const [progress, setProgress] = useState(0)

    // انیمیشن برای پر شدن پروگرس بار
    useEffect(() => {
        const approvedSteps = confirmedUsers.length
        const totalSteps = approvedSteps + 1
        const targetProgress = (approvedSteps / totalSteps) * 100

        const timer = setInterval(() => {
            setProgress((prev) => {
                const diff = targetProgress - prev
                if (Math.abs(diff) < 0.5) {
                    clearInterval(timer)
                    return targetProgress
                }
                return prev + diff * 0.1
            })
        }, 30)

        return () => clearInterval(timer)
    }, [confirmedUsers, dataGet])

    return (
        <>
            {loading ? <Loading /> : null}

            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    {notFound ? (
                        <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
                            <div className="bg-white p-8 rounded-xl shadow-md text-center max-w-md">
                                <h3 className="text-2xl font-bold text-red-600 mb-4">
                                    درخواست مرخصی یافت نشد
                                </h3>
                                <p className="text-gray-700">
                                    درخواست مربوطه لغو شده یا وجود ندارد
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="mx-4 my-6">
                            {/* Summary Card */}
                            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6 shadow-sm">
                                <div className="text-center text-red-800 font-medium">
                                    <span className="font-bold">
                                        مرخصی استفاده شده:
                                    </span>{' '}
                                    {user.user?.fullName || ''}
                                    {furloughMonthTime && (
                                        <span className="block md:inline-block md:mr-4">
                                            {
                                                furloughMonthTime.totalConfirmedFurloughs
                                            }{' '}
                                            مرخصی
                                            <span className="mx-2">|</span>
                                            {formatSecondsToTime(
                                                furloughMonthTime.totalFurloughHours
                                            )}{' '}
                                            ساعت
                                        </span>
                                    )}
                                </div>
                            </div>

                            {/* Request Details Card */}
                            <div className="bg-white rounded-xl shadow-lg  border border-gray-200">
                                {/* Header */}
                                <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                                    <h2 className="text-xl font-bold text-white">
                                        اطلاعات درخواست مرخصی
                                    </h2>
                                </div>

                                {/* Details Table */}
                                <div className="w-full p-6 bg-white rounded-xl shadow-md relative">
                                    <div className="flex justify-between items-start mb-6">
                                        <div>
                                            <h2 className="text-xl font-semibold text-gray-800">
                                                درخواست مرخصی
                                            </h2>
                                        </div>
                                        <div className="bg-blue-50 px-3 py-1 rounded-full text-blue-700 text-sm font-medium">
                                            {dataGet?.type_furlough === 'daily'
                                                ? 'مرخصی روزانه'
                                                : 'مرخصی ساعتی'}
                                        </div>
                                    </div>

                                    <div className="bg-gray-50 p-4 my-4 rounded-lg">
                                        <div className="flex items-center text-gray-500 mb-1">
                                            <FontAwesomeIcon
                                                icon={faUser}
                                                className="ml-2"
                                            />
                                            <span>نام و نام‌خانوادگی</span>
                                        </div>
                                        <div className="font-medium">
                                            {dataGet.user?.full_name || '-'}
                                        </div>
                                    </div>

                                    <div className="bg-gray-50 p-4 rounded-lg my-4">
                                        <div className="flex items-center text-gray-500 mb-1">
                                            <FontAwesomeIcon
                                                icon={faIdCard}
                                                className="ml-2"
                                            />
                                            <span>کد پرسنلی</span>
                                        </div>
                                        <div className="font-medium">
                                            {dataGet.user?.personnel_code ||
                                                '-'}
                                        </div>
                                    </div>

                                    {/* اطلاعات تاریخ و زمان */}
                                    <div className="flex w-full  mb-6">
                                        <div className="bg-gray-50 w-full p-3 rounded-lg">
                                            <p className="text-sm text-gray-500">
                                                تاریخ
                                            </p>
                                            <p className="font-medium my-2">
                                                {FormJsonToShamsiDay(
                                                    dataGet?.start_date
                                                )}

                                                {dataGet?.type_furlough ===
                                                'hourly' ? (
                                                    <span>
                                                        {' از ' +
                                                            FormJsonToShamsiTime(
                                                                dataGet?.start_date
                                                            ) +
                                                            ' تا ' +
                                                            FormJsonToShamsiTime(
                                                                dataGet?.end_date
                                                            )}
                                                    </span>
                                                ) : null}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="bg-gray-50 p-4  my-4 rounded-lg">
                                        <div className="flex items-center text-gray-500 mb-1">
                                            <FontAwesomeIcon
                                                icon={faCalendarAlt}
                                                className="ml-2"
                                            />
                                            <span>تاریخ ثبت درخواست</span>
                                        </div>
                                        <div className="font-medium">
                                            {FormJsonToShamsiDay(
                                                dataGet.created_at
                                            )}
                                            {'، '}
                                            {FormJsonToShamsiTime(
                                                dataGet.created_at
                                            )}
                                        </div>
                                    </div>

                                    {/* توضیحات درخواست */}
                                    {dataGet?.description && (
                                        <div className="bg-gray-50 p-3 rounded-lg mb-6">
                                                <p className="text-sm text-gray-500">
                                                درجه فوریت
                                                                                            </p>
                                            <p className="font-medium  my-2">
                                                {dataGet?.description}
                                            </p>
                                        </div>
                                    )}

                                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                                        روند تایید مرخصی
                                    </h3>

                                    {/* Progress bar اصلی */}
                                    <div className="relative mb-8">
                                        <div className="h-3 bg-gray-200 rounded-full overflow-hidden">
                                            <div
                                                className={`h-full bg-gradient-to-l ${dataGet?.status === 'pending' && 'from-yellow-400 to-yellow-600'} ${dataGet?.status === 'confirm' && 'from-green-400 to-green-600'} ${dataGet?.status === 'reject' && 'from-red-400 to-red-600'} rounded-full transition-all duration-500 ease-out`}
                                                style={{
                                                    width: `${dataGet?.status === 'pending' ? progress : '100'}%`,
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* لیست جزئیات تاییدکنندگان */}
                                    <div className="space-y-4">
                                        {approvalSteps.map((step) => (
                                            <div
                                                key={step.id}
                                                className={`p-4 rounded-lg border-l-4 transition-all duration-300
              ${step.status === 'confirm' ? 'border-green-500 bg-green-50' : ''}
              ${step.status === 'pending' ? 'border-yellow-500 bg-yellow-50 animate-pulse' : ''}
              ${step.status === 'reject' ? 'border-red-500 bg-red-50 animate-pulse' : ''}
            `}
                                            >
                                                <div className="flex justify-between items-center">
                                                    <div>
                                                        <h3 className="font-medium">
                                                            {step.name}
                                                        </h3>
                                                        <div className="flex flex-wrap gap-2 mt-1">
                                                            <span className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded">
                                                                {step.role}
                                                            </span>
                                                            {step.department && (
                                                                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                                                                    {
                                                                        step.department
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {step.status ===
                                                            'confirm' && (
                                                            <span className="px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full flex items-center">
                                                                <svg
                                                                    className="w-4 h-4 ml-1"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        strokeWidth="2"
                                                                        d="M5 13l4 4L19 7"
                                                                    />
                                                                </svg>
                                                                تایید شده
                                                            </span>
                                                        )}
                                                        {step.status ===
                                                            'pending' && (
                                                            <span className="px-3 py-1 bg-yellow-100 text-yellow-800 text-sm rounded-full flex items-center">
                                                                <svg
                                                                    className="w-4 h-4 ml-1 animate-spin"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        strokeWidth="2"
                                                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                                    />
                                                                </svg>
                                                                در انتظار تایید
                                                            </span>
                                                        )}
                                                        {step.status ===
                                                            'reject' && (
                                                            <span className="px-3 py-1 bg-red-100 text-red-800 text-sm rounded-full flex items-center">
                                                                <svg
                                                                    className="w-4 h-4 ml-1 animate-spin"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        strokeWidth="2"
                                                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                                    />
                                                                </svg>
                                                                رد شده
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                {step.comment && (
                                                    <div className="mt-3 p-2 bg-white rounded text-sm text-gray-700 border border-gray-200">
                                                        <span className="font-medium">
                                                            نظر {step.name}
                                                            :{' '}
                                                        </span>
                                                        {step.comment}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    {/* وضعیت کلی درخواست */}
                                    <div
                                        className={`mt-6 p-3 rounded-lg text-center font-medium
        ${dataGet?.status === 'pending' ? 'bg-yellow-100 text-yellow-800' : ''}
        ${dataGet?.status === 'confirm' ? 'bg-green-100 text-green-800' : ''}
        ${dataGet?.status === 'reject' ? 'bg-red-100 text-red-800' : ''}
      `}
                                    >
                                        {dataGet?.status === 'pending' &&
                                            'درخواست در حال بررسی است'}
                                        {dataGet?.status === 'confirm' &&
                                            'درخواست شما تایید شده است'}
                                        {dataGet?.status === 'reject' &&
                                            'درخواست شما رد شده است'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </main>
            </div>
        </>
    )
}

export default FurloughGetViewManagment
